import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

export type SubmitToastProps = {
    savedForms: string[];
    partiallySavedForms: string[];
    errorForms: string[];
    t: TFunction;
};

type ToastContentProps = {
    errorForms: string[];
    partiallySavedForms: string[];
    savedForms: string[];
};

// eslint-disable-next-line react-refresh/only-export-components
const ToastContent: React.FC<ToastContentProps> = ({ errorForms, partiallySavedForms, savedForms }) => {
    const { t } = useTranslation();
    return (
        <div>
            {errorForms.length > 0 && partiallySavedForms.length === 0 && savedForms.length === 0 ? (
                <p>{t('LEAD_DETAILS_GENERAL.DATA_NOT_SAVED')}</p>
            ) : (
                <p>{t('LEAD_DETAILS_GENERAL.DATA_PARTIALLY_SAVED')}</p>
            )}
            <div className="w-full h-2" />
            {savedForms.length > 0 && (
                <>
                    <p>{t('LEAD_DETAILS_GENERAL.SAVED_FORMS')}</p>
                    <ul className="list-disc pl-5">
                        {savedForms.map((form) => (
                            // @ts-expect-error -- Get the translation if it exists
                            <li key={form}>{t(`LEAD_DETAILS_FORMS.${form}`)}</li>
                        ))}
                    </ul>
                    <div className="w-full h-1" />
                </>
            )}
            {partiallySavedForms.length > 0 && (
                <>
                    <p>{t('LEAD_DETAILS_GENERAL.PARTIALLY_SAVED_FORMS')}</p>
                    <ul className="list-disc pl-5">
                        {partiallySavedForms.map((form) => (
                            // @ts-expect-error -- Get the translation if it exists
                            <li key={form}>{t(`LEAD_DETAILS_FORMS.${form}`)}</li>
                        ))}
                    </ul>
                    <div className="w-full h-1" />
                </>
            )}
            {errorForms.length > 0 && (
                <>
                    <p>{t('LEAD_DETAILS_GENERAL.ERROR_SAVING_DATA')}</p>
                    <ul className="list-disc pl-5">
                        {errorForms.map((form) => (
                            // @ts-expect-error -- Get the translation if it exists
                            <li key={form}>{t(`LEAD_DETAILS_FORMS.${form}`)}</li>
                        ))}
                    </ul>
                    <div className="w-full h-1" />
                </>
            )}
        </div>
    );
};

const showSubmitToast = ({ errorForms, partiallySavedForms, savedForms, t }: SubmitToastProps) => {
    if (savedForms.length > 0 && partiallySavedForms.length === 0 && errorForms.length === 0) {
        toast.success(t('LEAD_DETAILS_GENERAL.DATA_SAVED_SUCCESSFULLY'));
        return;
    }
    if (savedForms.length === 0 && partiallySavedForms.length === 0 && errorForms.length === 0) {
        toast.info(t('LEAD_DETAILS_GENERAL.NO_CHANGES'));
        return;
    }

    if (partiallySavedForms.length > 0 && errorForms.length === 0) {
        toast.warning(
            <ToastContent errorForms={errorForms} partiallySavedForms={partiallySavedForms} savedForms={savedForms} />,
        );
    } else if (errorForms.length > 0) {
        toast.error(
            <ToastContent errorForms={errorForms} partiallySavedForms={partiallySavedForms} savedForms={savedForms} />,
        );
    }
};

export { showSubmitToast };
